export default function Snack({id}: {id:string}){
    return(
        <>
            <div data-snack-id={id} data-snack-platform="web" data-snack-preview="true"
                 data-snack-theme="dark"
                 style={
                     {
                         overflow: 'hidden',
                         background: '#fbfcfd',
                         border: '1px solid var(--color-border)',
                         borderRadius: '4px',
                         height: '505px',
                         width: '100%',
                     }
                 }>

            </div>
            <script async src="https://snack.expo.dev/embed.js"></script>
        </>
    );
}